/* global Waypoint, Growlyflash, Inputmask, Turbo, Forms, DOMParser, bootstrap */
// Babel
import ReactOnRails from 'react-on-rails'
import { I18n, loadI18All } from 'packs/i18n'
import $ from 'initializers/init_jquery'
import moment from 'moment'
import 'underscore'
import 'react'
import 'prop-types'
import 'react-dom'
import 'classnames'
import 'jquery-ui/ui/widget'
import 'jquery-ui/ui/widgets/mouse'
import 'jquery-ui/ui/widgets/sortable'
import 'jquery-ui/ui/widgets/autocomplete'
import 'jquery.cookie/jquery.cookie'
import 'jquery.inputmask'
import 'jquery-minicolors/jquery.minicolors'
import 'inputmask.numeric.extensions'
import 'initializers/init_bootstrap'
import { disposeBootstrapInstances, disposeModals } from 'lib/bootstrap_overlays'
import { BOARDING_ACTION_UPDATED_EVENT } from 'components/on_off_boarding/useBoardingActionRefresh'
import { unmountRootsWithin, unmountDetachedRoots } from 'lib/scoped_react_roots'
import 'bootstrap4-editable'
import 'moment/locale/de'
import 'waypoints/lib/jquery.waypoints'
import 'growlyflash'
import 'stimulus_application'
import 'channels/index'
import flatpickr from 'flatpickr'
import { German } from 'flatpickr/dist/l10n/de'
import { Spanish } from 'flatpickr/dist/l10n/es'
import { French } from 'flatpickr/dist/l10n/fr'
import { Polish } from 'flatpickr/dist/l10n/pl'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import { AjaxAutoSelect2Initialize } from 'auto_select2/ajax_select2'
import 'nested_form/jquery_nested_form'
import 'cocoon/cocoon'
import '@hotwired/turbo-rails'
import FlexSearch from 'flexsearch'
import 'lib/sentry'
import 'lib/helpers'
import 'lib/forms'
import 'initializers/kompassify'

import Rails from '@rails/ujs'
window.ReactOnRails = ReactOnRails

require('select2-rails/select2')
require('select2-rails/select2_locale_de')

loadI18All()
if (!window._rails_loaded) {
  Rails.start()
  window._rails_loaded = true
}

window.FlexSearch = FlexSearch

const initMobileSelect2Behavior = () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  if (!isMobile) return

  if ($.fn.select2 && $.fn.select2.defaults) {
    $.fn.select2.defaults.shouldFocusInput = () => false
  }

  // Global touch handler for Select2 clear button on mobile.
  $(document).on('touchend', '.select2-container abbr', function (e) {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    const $select = $(this).closest('.select2-container').next('select')
    if (!$select.length) return false

    $select.select2('val', '')
    $select.val('')
    $select.trigger('change')
    $select.select2('close')

    return false
  })
}

initMobileSelect2Behavior()

const flatpickrLocales = {
  de: German,
  es: Spanish,
  fr: French,
  pl: Polish,
  pt: Portuguese
}

// Bootstrap doesn't observe its modal being removed/replaced from under it - hiding it
// cleanly (and clearing the backdrop/body state it owns) has to be done explicitly before
// a turbo_stream swap, same as the old jQuery/rails-ujs response did via this same helper.
Turbo.StreamActions.close_modal = function () {
  Helpers.forceModalHide()
}

// custom turbo action for reload turbo frame https://github.com/hotwired/turbo/issues/1215#issuecomment-2529420691
Turbo.StreamActions.reload = function () {
  // if the frame has a `src`, reload
  // if not but has a data-src => load that src
  // else do nothing
  document.querySelectorAll(`turbo-frame#${this.target}`).forEach((frame) => {
    if (frame.src) {
      frame.reload()
    } else if (frame.dataset.src) {
      frame.src = frame.dataset.src
    }
  })
}

Turbo.StreamActions.boarding_action_updated = function () {
  document.dispatchEvent(new CustomEvent(BOARDING_ACTION_UPDATED_EVENT, { detail: { actionId: this.target, employeeId: this.dataset.employeeId } }))
}

Growlyflash.defaults = $.extend(true, Growlyflash.defaults, {
  delay: 3000,
  target: 'body',
  align: 'center',
  class: ['alert', 'growlyflash', 'fade', 'text-center', 'rounded-0']
})
Growlyflash.KEY_MAPPING.invalid_auth_token_error = 'danger'

$(document).on('click.alert', '.growlyflash', function (e) {
  if ($(e.target).closest('[data-bs-dismiss="alert"]').length) return

  e.stopPropagation();
  ($(this)).alert('close')
  return false
})

const initScript = () => {
  // mobile screen scaling
  const minDeviceWidth = 500
  const currentDeviceWidth = window.screen.width
  const scale = currentDeviceWidth / minDeviceWidth
  const deviceVerticalOrientation = scale < 1
  const viewportMeta = document.getElementsByName('viewport')[0]
  if (deviceVerticalOrientation && viewportMeta) {
    // If device width smaller then minDeviceWidth, then adapt device scale for 100% zoom
    // Enable zoom on mobile device with maximum-scale=1.0
    viewportMeta.setAttribute('content', `width=${minDeviceWidth}, initial-scale=${scale}, maximum-scale=1.0`)
  }

  moment.locale(I18n.locale)

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

  // detect mobile device
  if (isMobile) {
    $('body').addClass('mobile-device')
  }

  AjaxAutoSelect2Initialize()

  // detect browser with no display:contents support
  // IE 10, 11, Edge
  // let body = document.getElementsByTagName('body')[0];
  // body.style.display = 'contents';
  // if (body.style.display !== 'contents') body.classList.add('no-contents-support');
  // body.style.display = '';
  function updatePageWidthCssRule () {
    if (document.getElementById('page')) {
      window.requestAnimationFrame(() => {
        document.documentElement.style.setProperty('--actualPageWidth', `${document.getElementById('page').clientWidth}px`)
      })
    }
  }
  updatePageWidthCssRule()
  $(window).on('resize', updatePageWidthCssRule)

  // default Waypoint context instead of window
  Waypoint.defaults.context = document.getElementById('page')

  // flatpickr locale
  flatpickr.localize(flatpickrLocales[I18n.locale])
  flatpickr.defaultConfig.allowInput = true
  flatpickr.defaultConfig.dateFormat = 'd.m.Y'
  flatpickr.defaultConfig.time_24hr = true
  flatpickr.defaultConfig.minuteIncrement = 15

  // Tooltips
  const tooltipOptions = {
    container: 'body',
    boundary: 'viewport',
    html: true,
    placement: 'top'
  }
  window.createTooltips(document.querySelectorAll('[data-bs-toggle="tooltip"]'), tooltipOptions)

  // // Popovers
  const popoverOptions = {
    container: 'body',
    boundary: 'window',
    html: true,
    placement: 'auto',
    sanitize: false
    // template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title popover-header"></h3><div class="popover-content popover-body"></div></div>'
  }
  window.createPopovers(document.querySelectorAll('[data-bs-toggle="popover"]'), popoverOptions)

  // Inputmask aliases
  Inputmask.extendAliases({
    localized_numeric: {
      alias: 'numeric',
      radixPoint: I18n.t('number.format.separator'),
      groupSeparator: I18n.t('number.format.delimiter'),
      digits: 2,
      autoGroup: true,
      prefix: '',
      rightAlign: false,
      allowMinus: false
    }
  })

  // Disable HTML5 validations for inactive tabs
  $(document).on('shown.bs.tab', 'a[data-bs-toggle="tab"]', (e) => {
    $(':input[required]:hidden').removeAttr('required').addClass('wasrequired')
    $('.wasrequired:visible').removeClass('wasrequired').prop('required', 'required')
  })

  const removeCandidatePositionRowFromDom = (candidatePositionId) => {
    if (!candidatePositionId) return
    const row = document.getElementById(`candidate_position_${candidatePositionId}`)
    if (row) row.remove()
  }

  $(document).on('ajax:success', 'a[data-remote="true"][data-method="delete"]', function () {
    const href = this.getAttribute('href')
    if (!href) return

    const match = href.match(/\/candidate_positions\/(\d+)(?:\?|$)/)
    if (!match) return

    const candidatePositionId = match[1]

    if (window.Helpers && typeof window.Helpers.forceModalHide === 'function') {
      window.Helpers.forceModalHide()
    }

    removeCandidatePositionRowFromDom(candidatePositionId)
  })

  // Solve z-index conflicts with topnav
  $(document).on('show.bs.modal', '.modal', (e) => {
    const modal = $(e.currentTarget)

    // Modals inside the fixed #hidden-side panel are trapped in its stacking context
    if (modal.parents('#hidden-side').length) {
      modal.appendTo(document.body)
    }

    if (modal.parents('.topnav').length) {
      $('body').addClass('topnav-modal-open')
      modal.one('hidden.bs.modal', () => $('body').removeClass('topnav-modal-open'))
    }
    if (modal.parents('#page').length) {
      $('body').addClass('page-modal-open')
      modal.one('hidden.bs.modal', () => $('body').removeClass('page-modal-open'))
    }
    if (modal.parents('.sidebar').length) {
      $('body').addClass('sidebar-modal-open')
      modal.one('hidden.bs.modal', () => $('body').removeClass('sidebar-modal-open'))
    }
    if (modal.parents('.infobar').length) {
      $('body').addClass('infobar-modal-open')
      modal.one('hidden.bs.modal', () => $('body').removeClass('infobar-modal-open'))
    }
  })

  $(document).on('shown.bs.tab', () => $(window).trigger('resize'))

  // Note: Topnav search functionality has been moved to React component (navigation_search/BasicSearch.js.jsx)

  // Print button
  $(document)
    .off('click', '.print')
    .on('click', '.print', (e) => {
      console.log('print handler attached')
      e.preventDefault()
      setTimeout(() => window.print(), 100)
    })
}

window.submitCandidateForm = () => document.querySelector('form#new_candidate').submit()
window.submitEmployeeForm = () => document.querySelector('form#new_employee').submit()
window.submitUserForm = () => document.querySelector('form#new_user').submit()

const syncMobileSidenavLayoutState = ({ collapseSidenav = true } = {}) => {
  const body = document.body
  if (!body) return

  const hasTopnav = !!document.querySelector('.topnav')
  const isPortalLayout = !!document.querySelector('.sidenav-mobile[data-controller="portal--sidenav-mobile"]')
  const hasMobileSidenavToggle = !!document.querySelector('.sidenav-mobile[data-controller="mobile-sidenav"]')

  if (hasTopnav) {
    body.classList.remove('no-topnav')
  } else if (isPortalLayout) {
    body.classList.add('no-topnav')
  }

  if (hasMobileSidenavToggle && hasTopnav) {
    body.classList.add('has-mobile-sidenav')
  } else {
    body.classList.remove('has-mobile-sidenav')
  }

  if (collapseSidenav) {
    body.classList.remove('sidenav-expanded')
    body.style.top = ''
  }
}

window.safeTrim = (value) => {
  return value ? String(value).trim() : ''
}

const resetIOSViewportZoom = () => {
  const ua = navigator.userAgent
  const isIOSSafari =
    /^((?!chrome|android).)*safari/i.test(ua) &&
    (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1))
  if (!isIOSSafari) return
  if (!window.visualViewport || window.visualViewport.scale === 1) return
  const meta = document.querySelector('meta[name="viewport"]')
  if (!meta) return
  const original = meta.getAttribute('content')
  meta.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1')
  window.requestAnimationFrame(() => meta.setAttribute('content', original))
}

// growlyflash's own listener (vendored gem, app/assets/javascripts/growlyflash.js.coffee)
// only ever reads window.flashes once, from its own `jQuery -> Growlyflash.listen_on(this)`
// $(document).ready singleton - it never re-fires under Turbo, so a flash set by a
// Turbo-driven navigation (frame or Drive) past the very first page load is silently
// dropped. Growlyflash.growl/FlashStruct are plain public functions though (not tied to
// that singleton), so re-implement just the static-notice half of process_static here,
// called on every Turbo render instead of once.
const processStaticFlashes = () => {
  if (!window.flashes) return
  Object.entries(window.flashes).forEach(([key, msg]) => {
    if (!msg) return
    Growlyflash.growl(new Growlyflash.FlashStruct(msg, key))
  })
  delete window.flashes
}

const initializeTurboPage = () => {
  if (window.HCM_I18N_DEFAULT_LOCALE) I18n.defaultLocale = window.HCM_I18N_DEFAULT_LOCALE
  if (window.HCM_I18N_LOCALE) I18n.locale = window.HCM_I18N_LOCALE
  ReactOnRails.reactOnRailsPageLoaded()
  initScript()
  syncMobileSidenavLayoutState()
  resetIOSViewportZoom()
  Helpers.initHoverDropdowns()
  Helpers.dropdown2popover($('.sidenav .dropdown'))
  Forms.initForm()
  window.Preloader?.init()
  processStaticFlashes()
}

let initializedOnTurboRender = false

// EventListeners
document.addEventListener('turbo:load', () => {
  if (initializedOnTurboRender) {
    initializedOnTurboRender = false
    return
  }

  initializeTurboPage()
})

// turbo:load does not fire when Turbo renders a failed form submission
// (e.g. 422 validation errors), so initialize the page on turbo:render too.
document.addEventListener('turbo:render', () => {
  if (document.documentElement.hasAttribute('data-turbo-preview')) return

  initializeTurboPage()
  initializedOnTurboRender = true
})

// Intercept Turbo Stream rendering to re-mount React components after DOM updates
// Without this, React components inside Turbo Stream responses won't initialize
// because React doesn't know about dynamically inserted HTML.
document.addEventListener('turbo:before-stream-render', (event) => {
  const defaultRender = event.detail.render

  event.detail.render = (streamElement) => {
    // First, let Turbo insert the HTML into the DOM
    defaultRender(streamElement)

    // Then re-mount any React components in the newly added content, and (re)run the
    // same jQuery widget setup (datepickers, select2, autosize, ...) a normal page load
    // gets via initializeTurboPage - without this, any such widget inside stream-rendered
    // content is dead on arrival. Each Forms.init* is idempotent per-element (checks for
    // an existing instance before creating one), so re-scanning the whole document is safe.
    setTimeout(() => {
      unmountDetachedRoots()
      ReactOnRails?.reactOnRailsPageLoaded()
      Forms.initForm()
    }, 10)
  }
})

// Turbo's FrameController overwrites the frame's `src` with the response's own URL once
// a request succeeds (loadResponse: `this.sourceURL = fetchResponse.response.url`), and
// a Fetch Response's `.url` never includes a hash fragment (hashes are client-only,
// never sent to or echoed back by the server). The piggy-backed history-advancing visit
// (data-turbo-action: 'advance') then pushes history from that now-hash-less `src`, so
// any hash on the originally clicked link - e.g. the sidenav's "Edit personal data"
// (#personal_data) or skills/compare's "Compare skills" (#skills-chart) tab - is
// silently dropped, leaving whichever tab the page's static HTML hardcodes as the
// default active one. Confirmed via instrumentation: the hash is still present at
// turbo:before-fetch-request, already stripped by turbo:frame-load, and something in
// the piggy-backed visit's own history handling sets it to a (wrong) value again by
// turbo:load. So this needs restoring at both ends: early (before
// ReactOnRails.reactOnRailsPageLoaded() mounts components that read location.hash once
// at mount time, e.g. candidates/Form.jsx's useState initializer) and late (after
// Turbo's own piggy-backed history rewrite has fully settled, for the final URL and any
// plain Bootstrap data-bs-toggle="tab" elements Helpers.handleTabAnchors drives).
let pendingFrameHash = null
let pendingFrameRequestUrl = null

document.addEventListener('turbo:before-fetch-request', (event) => {
  if (event.target?.id !== 'page') return
  try {
    const url = new URL(event.detail.url, window.location.href)
    pendingFrameHash = url.hash
    pendingFrameRequestUrl = url.href
  } catch (e) {
    pendingFrameHash = null
    pendingFrameRequestUrl = null
  }
})

// A frame request that errors or gets aborted (e.g. the user navigates elsewhere before it
// resolves) never reaches turbo:frame-load/turbo:load, so pendingFrameHash would otherwise
// never get cleared - a later, unrelated Turbo Drive visit would then wrongly inherit this
// stale hash. Only clear it if this error belongs to the request pendingFrameRequestUrl
// still points to: a newer #page request may already be in flight (having overwritten both
// variables) by the time an older request's error/abort is reported.
document.addEventListener('turbo:fetch-request-error', (event) => {
  if (event.target?.id !== 'page') return
  const erroredUrl = event.detail?.request?.url?.href
  if (erroredUrl && erroredUrl !== pendingFrameRequestUrl) return
  pendingFrameHash = null
  pendingFrameRequestUrl = null
})

const restorePendingFrameHash = () => {
  if (!pendingFrameHash) return
  if (location.hash !== pendingFrameHash) {
    history.replaceState(history.state, '', location.pathname + location.search + pendingFrameHash)
  }
}

document.addEventListener('turbo:frame-load', (event) => {
  restorePendingFrameHash()
  // Each call is independently try/caught: a stale-DOM crash in any one of these
  // (common after a frame swap - see the gon/popover/sidenav fixes elsewhere in this
  // file) must not stop the rest from running. Without this, a single throw here
  // silently skips Preloader.init below and everything after it, with no visible sign
  // beyond "the page looks like nothing happened" - exactly the bug it's guarding against.
  try { ReactOnRails.reactOnRailsPageLoaded() } catch (e) { console.error('ReactOnRails frame-load error:', e) }
  try { initScript() } catch (e) { console.error('initScript frame-load error:', e) }
  try { syncMobileSidenavLayoutState({ collapseSidenav: event.target?.id === 'page' }) } catch (e) { console.error('syncMobileSidenavLayoutState frame-load error:', e) }
  // Preloader.init only ran from preloader.js's own $(document).ready, which fires
  // once per real browser load and never again for Turbo-driven navigation. Elements
  // like #candidate_events (app/views/candidates/show.html.haml) rely on it to fetch
  // their actual content - without this, they stay a permanently empty shell after a
  // frame-scoped visit. init() itself skips elements already marked 'preloaded', so
  // it's safe to call on every frame load.
  try { window.Preloader?.init() } catch (e) { console.error('Preloader frame-load error:', e) }
  try { processStaticFlashes() } catch (e) { console.error('Growlyflash frame-load error:', e) }
  try { Helpers.handleTabAnchors() } catch (e) { console.error('handleTabAnchors frame-load error:', e) }
})

document.addEventListener('turbo:before-frame-render', (event) => {
  unmountRootsWithin(event.target)
})

document.addEventListener('turbo:load', () => {
  if (!pendingFrameHash) return
  restorePendingFrameHash()
  pendingFrameHash = null
  pendingFrameRequestUrl = null
  try { Helpers.handleTabAnchors() } catch (e) { console.error('handleTabAnchors hash-restore error:', e) }
})

// Turbo's own top-of-page progress bar (Session#progressBarDelay) only tracks the
// Navigator/Visit lifecycle, so it shows automatically on ordinary (non-frame) Drive
// page loads elsewhere in the app. It does not track a <turbo-frame>'s own fetch, which
// is what every candidate sidenav click actually waits on - so without this, frame
// navigation has no visual loading feedback at all. This reimplements the same
// trickle/fade behavior (same 500ms delay, same easing) scoped to the #page frame only.
const FrameProgressBar = {
  element: null,
  value: 0,
  visible: false,
  showTimeout: null,
  trickleInterval: null,
  pending: new Map(),

  ensureElement () {
    if (this.element) return this.element
    const el = document.createElement('div')
    el.className = 'frame-progress-bar'
    this.element = el
    return el
  },

  begin (signal, url) {
    this.pending.set(signal, url)
    signal.addEventListener('abort', () => this.finish(signal), { once: true })
    this.cancelScheduledShow()
    this.showTimeout = window.setTimeout(() => this.show(), 500)
  },

  finish (signal) {
    if (!this.pending.delete(signal)) return
    window.setTimeout(() => {
      if (this.pending.size === 0) this.hide()
    }, 0)
  },

  finishByResponse (fetchResponse) {
    const response = fetchResponse.response
    const entries = [...this.pending]
    const entry = response.redirected
      ? entries[0]
      : entries.find(([, url]) => url === withoutHash(response.url))
    if (entry) this.finish(entry[0])
  },

  cancelScheduledShow () {
    if (this.showTimeout == null) return
    window.clearTimeout(this.showTimeout)
    this.showTimeout = null
  },

  show () {
    if (this.visible) return
    this.visible = true
    this.setValue(0)
    document.body.appendChild(this.ensureElement())
    this.trickleInterval = window.setInterval(() => this.setValue(this.value + Math.random() / 100), 300)
  },

  hide () {
    this.cancelScheduledShow()
    if (!this.visible) return
    this.setValue(1)
    window.clearInterval(this.trickleInterval)
    this.trickleInterval = null
    const el = this.element
    el.style.opacity = '0'
    window.setTimeout(() => el.parentNode?.removeChild(el), 450)
    this.visible = false
  },

  setValue (value) {
    this.value = Math.min(value, 1)
    const el = this.ensureElement()
    el.style.opacity = '1'
    el.style.width = `${10 + this.value * 90}%`
  }
}

const withoutHash = (href) => {
  const url = new URL(href, window.location.href)
  url.hash = ''
  return url.href
}

document.addEventListener('turbo:before-fetch-request', (event) => {
  if (event.target?.id !== 'page') return
  const { fetchOptions, url } = event.detail
  FrameProgressBar.begin(fetchOptions.signal, withoutHash(url))
})

document.addEventListener('turbo:before-fetch-response', (event) => {
  if (event.target?.id !== 'page') return
  FrameProgressBar.finishByResponse(event.detail.fetchResponse)
})

// Same gap as pendingFrameHash above: a request that errors or gets aborted never reaches
// turbo:before-fetch-response, so without this the progress bar scheduleShow() started and
// never gets hidden - it's stuck animating indefinitely for a request that will never finish.
document.addEventListener('turbo:fetch-request-error', (event) => {
  if (event.target?.id !== 'page') return
  FrameProgressBar.finish(event.detail?.request?.abortSignal)
})

// The candidate "page" frame keeps .page-sidenav outside its swapped region (so the
// sidebar's React state survives tab-to-tab navigation), which means Turbo never
// updates the sidenav's active-tab highlighting on its own. The response still renders
// a fresh .page-sidenav though (see layouts/turbo_rails/frame.html.haml) - read it
// straight out of the frame's own fetch response (cloned, so it doesn't interfere with
// Turbo's own consumption of the body) and swap it in, so the real server-side
// active-state logic stays the single source of truth instead of being duplicated in JS.
// (event.detail.newFrame on turbo:before-frame-render is not useful for this - its
// ownerDocument is the live, not-yet-updated document, not the parsed response.)
document.addEventListener('turbo:before-fetch-response', (event) => {
  if (event.target?.id !== 'page') return

  event.detail.fetchResponse.responseHTML?.then((html) => {
    if (!html) return
    const freshSidenav = new DOMParser().parseFromString(html, 'text/html').querySelector('.page-sidenav')
    const liveSidenav = document.querySelector('.page-sidenav')
    if (!freshSidenav || !liveSidenav) return

    // The dropdown submenus (Experience, Skills, Edit profile) are converted into
    // Bootstrap popovers by Helpers.dropdown2popover, which only runs from
    // initializeTurboPage on turbo:load/turbo:render - full-page visits that never fire
    // for this frame-scoped navigation. Without disposing the old popover instances
    // first, their body-appended bubbles are orphaned (never disappear, since they're
    // outside .page-sidenav and this innerHTML swap doesn't touch them); without
    // re-running dropdown2popover after, the fresh dropdown markup never gets hover
    // behavior wired up at all and falls back to a plain link (no popover, no turbo-frame
    // submenu interaction).
    // The workflow-tab-frame's server-rendered markup is just the empty <turbo-frame
    // src="..." loading="lazy"> stub (see candidates/_sidenav.html.haml) - its actual
    // content (icon, label, badge count) only exists client-side, after Turbo fetches
    // it in. Letting the innerHTML swap below drop in freshSidenav's copy would replace
    // the already-loaded frame with that blank stub, so the tab visibly disappears for
    // however long the subsequent re-fetch takes - even a fast one. Pull the live,
    // already-loaded frame out first and splice it back in after the swap so it's never
    // actually removed from the DOM; nothing to visibly reload, since the workflow
    // counter is the same candidate-wide data regardless of which sub-page you're on.
    const liveWorkflowFrame = liveSidenav.querySelector('.workflow-tab-frame')

    $('.dropdown', liveSidenav).each(function () { $(this).popover?.('dispose') })
    liveSidenav.innerHTML = freshSidenav.innerHTML
    Helpers.initHoverDropdowns(liveSidenav)
    Helpers.dropdown2popover($('.dropdown', liveSidenav))

    if (liveWorkflowFrame?.hasAttribute('complete')) {
      liveSidenav.querySelector('.workflow-tab-frame')?.replaceWith(liveWorkflowFrame)
    } else {
      // Not loaded yet (e.g. still mid-fetch from the very first page load) - nothing
      // worth preserving, so fall back to the old deterministic-fetch behavior instead
      // of waiting on the lazy-load IntersectionObserver to re-trigger.
      liveSidenav.querySelector('.workflow-tab-frame')?.reload()
    }
  }).catch((e) => console.error('Sidenav sync error:', e))

  // #after-footer (modals rendered via render_modal_with_link(..., after_footer: true))
  // has the exact same staleness problem as .page-sidenav above, with a worse failure
  // mode: a modal trigger whose target isn't in the stale HTML hands Bootstrap a null
  // element, and Modal#show crashes trying to read config off the half-constructed
  // instance that results. Swap it in the same way, disposing any modal instances first
  // so an open modal from the outgoing page doesn't leak its backdrop.
  event.detail.fetchResponse.responseHTML?.then((html) => {
    if (!html) return
    const freshFooter = new DOMParser().parseFromString(html, 'text/html').getElementById('after-footer')
    const liveFooter = document.getElementById('after-footer')
    if (!freshFooter || !liveFooter) return

    disposeModals(liveFooter)
    liveFooter.innerHTML = freshFooter.innerHTML
  }).catch((e) => console.error('After-footer sync error:', e))

  event.detail.fetchResponse.responseHTML?.then((html) => {
    if (!html) return
    const freshSidebar = new DOMParser().parseFromString(html, 'text/html').querySelector('.page-sidebar')
    const liveSidebar = document.querySelector('.page-sidebar')
    if (!freshSidebar || !liveSidebar) return

    const hasContent = (el) => el.innerHTML.trim() !== ''
    if (hasContent(freshSidebar) === hasContent(liveSidebar)) return

    unmountRootsWithin(liveSidebar)
    liveSidebar.innerHTML = freshSidebar.innerHTML
    ReactOnRails.reactOnRailsPageLoaded()
  }).catch((e) => console.error('Sidebar sync error:', e))
})

document.addEventListener('turbo:before-render', (event) => {
  if (typeof ReactOnRails.reactOnRailsPageUnloaded === 'function') {
    ReactOnRails.reactOnRailsPageUnloaded()
  } else if (typeof ReactOnRails.clearHydratedStores === 'function') {
    ReactOnRails.clearHydratedStores()
  }
  document.body?.classList.remove('sidenav-expanded')
  if (document.body) document.body.style.top = ''

  disposeBootstrapInstances()

  const newBody = event?.detail?.newBody
  const body = document.body
  if (!newBody || !body) return

  const preserveClasses = ['mobile-device', 'no-contents-support']
  const preserved = preserveClasses.filter((c) => body.classList.contains(c))

  body.className = `${newBody.className} ${preserved.join(' ')}`.trim()

  if (newBody.dataset) {
    if (newBody.dataset.controller) body.dataset.controller = newBody.dataset.controller
    if (newBody.dataset.action) body.dataset.action = newBody.dataset.action
  }
})

document.addEventListener('turbo:fetch-request-error', (event) => {
  const error = event.detail?.error
  if (!error) return
  const signal = event.detail?.fetchOptions?.signal
  const isAbort = error.name === 'AbortError' || signal?.aborted === true
  if (isAbort) event.preventDefault()
})

document.addEventListener('turbo:before-cache', () => {
  disposeBootstrapInstances()
})

// Global mobile scroll handler for all select2
// Use click delegation on select2 container since select2-open event doesn't bubble
$(document).on('click', '.select2-container', function () {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768
  if (isMobile) {
    const container = this
    setTimeout(() => {
      container.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 150)
  }
})
